import BusinessInsightsIcon from './BusinessInsightsIcon';

export default BusinessInsightsIcon;
